var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Validation from "@irati/utils/validation";
import Input from "@irati/ui/src/FormItem/Input";
export var teamSchema = function (required) {
    if (required === void 0) { required = false; }
    return Validation.string(required && "admin.helpers.getTeamSchema.validation.string")
        .min(3, "admin.helpers.getTeamSchema.validation.min")
        .max(50, "admin.helpers.getTeamSchema.validation.max")
        .matches(/.*\S.*/, "admin.helpers.getTeamSchema.validation.matches");
};
var TeamPublicName = /** @class */ (function (_super) {
    __extends(TeamPublicName, _super);
    function TeamPublicName() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TeamPublicName.prototype.render = function () {
        var _a = this.props, label = _a.label, placeholder = _a.placeholder, validation = _a.validation, value = _a.value, onChange = _a.onChange;
        return (React.createElement(Input, { name: "teamName", label: label, type: "text", placeholder: placeholder, value: value, onChange: onChange, validation: validation }));
    };
    TeamPublicName.defaultProps = {
        label: "platform.createTeamName.form.input.label",
        placeholder: "platform.createTeamName.form.input.placeholder",
        validation: teamSchema(true)
    };
    return TeamPublicName;
}(PureComponent));
export default TeamPublicName;
